import { createSlice, createSelector } from "@reduxjs/toolkit";
import { ofType } from "redux-observable";
import { of } from "rxjs";
import { concatMap, map, catchError } from "rxjs/operators";
import { UserNotificationType, noNotification } from "@nxplatform/platform-entities";
import { getResponseMessage } from "../http/helpers/get-response-message.js";
const NOTIFICATION_FEATURE_KEY = "notification";
const initialNotificationState = {
  id: null,
  state: false,
  message: null,
  type: null,
  params: null,
  queuedNotifications: [],
  lastSeenId: null
};
const notificationSlice = createSlice({
  name: NOTIFICATION_FEATURE_KEY,
  initialState: initialNotificationState,
  reducers: {
    notificationHide: (state, action) => {
      state.id = null;
      state.state = false;
      state.type = null;
      state.message = null;
    },
    notificationShow: (state, { payload }) => {
      if (!(payload == null ? void 0 : payload.id) || (payload == null ? void 0 : payload.id) !== state.lastSeenId) {
        state.state = true;
        state.type = payload.type;
        state.message = payload.text;
        state.params = payload.params;
        if (payload == null ? void 0 : payload.id) state.id = payload == null ? void 0 : payload.id;
      }
    },
    queueNotificationShow: (state, { payload }) => {
      state.queuedNotifications = [
        ...state.queuedNotifications,
        {
          id: payload.id,
          state: true,
          message: payload.text,
          params: payload.params,
          type: payload.type
        }
      ];
    },
    showNextQueuedNotification: (state) => {
      if (!state.queuedNotifications.length) return;
      const {
        state: visible,
        params,
        type,
        message,
        id
      } = state.queuedNotifications.pop();
      state.id = id;
      state.state = visible;
      state.params = params;
      state.type = type;
      state.message = message;
    },
    notificationSeenUpdateStart: (state, action) => {
      state.state = false;
      state.lastSeenId = action.payload.notificationId;
    },
    notificationSeenUpdateFail: (state, action) => {
      state.state = true;
    },
    notificationSeenUpdateSuccess: (state, action) => {
      state.state = true;
    }
  }
});
const notificationReducer = notificationSlice.reducer;
const {
  notificationHide,
  notificationShow,
  queueNotificationShow,
  showNextQueuedNotification
} = notificationSlice.actions;
const getNotificationState = (rootState) => rootState[NOTIFICATION_FEATURE_KEY];
const selectNotificationState = createSelector(
  getNotificationState,
  (s) => s.state
);
const selectNotificationMessage = createSelector(
  getNotificationState,
  (s) => s.message
);
const selectNotificationType = createSelector(
  getNotificationState,
  (s) => s.type
);
const selectNotificationParam = createSelector(
  getNotificationState,
  (s) => s.params
);
const selectQueuedNotifications = createSelector(
  getNotificationState,
  (s) => s.queuedNotifications
);
const {
  notificationSeenUpdateStart,
  notificationSeenUpdateSuccess,
  notificationSeenUpdateFail
} = notificationSlice.actions;
const setNotificationSeen = (notificationId) => ({ type: notificationSeenUpdateStart().type, payload: notificationId });
const setNotificationSeenEpic = (action$, state$, { Api }) => action$.pipe(
  ofType(notificationSeenUpdateStart.type),
  concatMap((action) => Api.notification.setNotificationSeen(action.payload).pipe(
    map((data) => notificationSeenUpdateSuccess(data)),
    catchError((err) => of(notificationSeenUpdateFail(err)))
  ))
);
const ignoredStatus = [0];
const showErrorNotification = (action, store, errorMessage) => {
  const text = getResponseMessage(action.payload, errorMessage);
  const { payload } = action;
  const { status } = payload || {};
  if (!ignoredStatus.includes(status)) {
    store.dispatch(
      notificationShow({
        text,
        type: UserNotificationType.Fail
      })
    );
  }
};
const showSuccessNotification = (action, store, successMessage) => {
  if (action.payload && !action.payload[noNotification]) {
    const message = getResponseMessage(action.payload, successMessage);
    const parsedMessage = () => {
      if (typeof message === "object" && "text" in message) {
        return message == null ? void 0 : message.text;
      }
      return message;
    };
    store.dispatch(
      notificationShow({ text: parsedMessage(), type: UserNotificationType.Success })
    );
  }
};
export {
  NOTIFICATION_FEATURE_KEY,
  getNotificationState,
  initialNotificationState,
  notificationHide,
  notificationReducer,
  notificationSeenUpdateFail,
  notificationSeenUpdateStart,
  notificationSeenUpdateSuccess,
  notificationShow,
  notificationSlice,
  queueNotificationShow,
  selectNotificationMessage,
  selectNotificationParam,
  selectNotificationState,
  selectNotificationType,
  selectQueuedNotifications,
  setNotificationSeen,
  setNotificationSeenEpic,
  showErrorNotification,
  showNextQueuedNotification,
  showSuccessNotification
};
